// App Badge API utility for PWA icon badge management

// Extend Navigator interface for Badge API
declare global {
  interface Navigator {
    setAppBadge?(count?: number): Promise<void>;
    clearAppBadge?(): Promise<void>;
  }
}

class AppBadgeManager {
  private static instance: AppBadgeManager;

  static getInstance(): AppBadgeManager {
    if (!AppBadgeManager.instance) {
      AppBadgeManager.instance = new AppBadgeManager();
    }
    return AppBadgeManager.instance;
  }

  /**
   * Set the app icon badge count
   * @param count Number to display on the badge (0 clears the badge)
   */
  setBadge(count: number): void {
    // Try main thread Badge API first (newer browsers)
    if ('setAppBadge' in navigator && navigator.setAppBadge) {
      if (count > 0) {
        navigator.setAppBadge(count).catch(console.error);
      } else {
        navigator.clearAppBadge?.().catch(console.error);
      }
    }
    // Fallback to service worker message
    else if ('serviceWorker' in navigator && navigator.serviceWorker?.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'SET_BADGE',
        count
      });
    }
  }

  /**
   * Clear the app icon badge
   */
  clearBadge(): void {
    this.setBadge(0);
  }

  /**
   * Check if Badge API is supported
   */
  isSupported(): boolean {
    return 'setAppBadge' in navigator ||
           ('serviceWorker' in navigator && !!navigator.serviceWorker?.controller);
  }
}

export const appBadgeManager = AppBadgeManager.getInstance();